export default __webpack_public_path__ + "static/media/chain-18.4987ecd5.png";